<template>
  <div :class="[`x4`, className || ``]">
    <div class="x4-1">
      <div class="overlap-group1">
        <div class="overlap-group-2">
          <bg :src="bgProps.src" />
          <img
            class="icon-cart"
            src="/otplanding/shape@2x.png"
            alt="icon-cart"
          />
        </div>
        <div class="uskoro inter-bold-link-water-24px">uskoro</div>
      </div>
      <div class="text-2">
        <div class="instant-features inter-bold-link-water-24px">eCommerce</div>
        <p class="duis-aute-irure-dolo-1 inter-normal-gull-gray-18px">
          <span class="span-3 inter-normal-gull-gray-18px">jedan klik do vašeg <br /></span
          ><span class="span-3 inter-bold-gull-gray-18px">miniShop webStore B2B rešenja<br /></span
          ><span class="span-3 inter-normal-gull-gray-18px">integracija sa kurirskim službama<br /></span
          ><span class="span-3 inter-bold-gull-gray-18px">automatizovano procesuiranje uplata</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import Bg from "./Bg";
export default {
  name: "X4",
  components: {
    Bg,
  },
  props: ["className", "bgProps"],
};
</script>

<style>
.x4 {
  display: flex;
  height: 247px;
  min-width: 325px;
  position: relative;
}

.x4-1 {
  align-items: flex-end;
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-height: 247px;
  width: 327px;
}

.overlap-group1 {
  height: 81px;
  margin-right: 2px;
  position: relative;
  width: 194px;
}

.overlap-group-2 {
  height: 64px;
  left: 0;
  position: absolute;
  top: 17px;
  width: 64px;
}

.icon-cart {
  height: 36px;
  left: 14px;
  position: absolute;
  top: 14px;
  width: 36px;
}

.uskoro {
  left: 62px;
  letter-spacing: -0.25px;
  line-height: 34px;
  position: absolute;
  text-align: center;
  top: 0;
  white-space: nowrap;
  width: 132px;
}

.text-2 {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 8px;
  height: 150px;
  margin-right: 2px;
  width: 325px;
}

.instant-features {
  letter-spacing: -0.25px;
  line-height: 34px;
  margin-left: 1px;
  text-align: center;
  text-decoration: underline;
  white-space: nowrap;
  width: 286px;
}

.duis-aute-irure-dolo-1 {
  letter-spacing: -0.25px;
  line-height: 27px;
  min-height: 108px;
  text-align: center;
  width: 325px;
}

.x4.x4-2 {
  margin-left: unset;
}
</style>
